


































































import { Component, Prop } from "vue-property-decorator";
import { requiredRule } from "@/lib/rules/requiredRule.ts";
import { emailRule } from "@/lib/rules/contactRule.ts";
import LoginMixin from "@/mixins/LoginMixin.vue";
import { LoginCardEnum } from "@/store/enum/loginCardEnum";
import LoginPasswordRequirementList from "@/components/login/LoginPasswordRequirementList.vue";
import { UserModule } from "@/store/modules/user.store";
import { ConfirmPasswordDto } from "@/services/mrfiktiv/v1/mrfiktiv.api";

@Component({
  components: { LoginPasswordRequirementList }
})
export default class LoginReset extends LoginMixin {
  @Prop({ default: "" })
  initialCode!: string;

  @Prop()
  changeMail!: Function;

  @Prop()
  changePassword!: Function;

  @Prop()
  showBackToLoginReset!: Function;

  isFormValid = false;
  submitted = false;

  get isResetButtonDisabled() {
    if (!this.isFormValid || this.password2 !== this.password1) {
      return true;
    }
    if (this.submitted) {
      return true;
    }
    return false;
  }

  code = this.initialCode || "";

  isPasswordVisible2 = false;
  isPasswordVisible3 = false;

  get getIsFormValid() {
    return this.isFormValid && this.password1 === this.password2;
  }

  get required() {
    return [requiredRule()];
  }

  get emailRules() {
    return [requiredRule(), emailRule()];
  }

  constructor() {
    super();
  }

  backToLogin() {
    this.showBackToLoginReset();
    this.changeMail(this.mail);
    this.changePassword(this.password1);
    this.changeCard(LoginCardEnum.LOGIN);
  }

  async submit() {
    this.changeMail(this.mail);
    this.changePassword(this.password2);
    const confirmPasswordDto: ConfirmPasswordDto = {
      username: this.mail,
      password: this.password2,
      code: this.code
    };
    try {
      await UserModule.confirmPassword(confirmPasswordDto);
      this.submitted = true;
      this.checkIfUserIsLoggedInAndRedirect();
      this.setSuccessMessage(
        () => this.changeCard(LoginCardEnum.LOGIN),
        "Falls Ihr Code korrekt ist, wird Ihr Passwort zurückgesetzt. Sie können sich nun anmelden."
      );
    } catch (error) {
      this.$log.info("Reset failed");
      this.setFailMessage("Etwas ging schief.. Prüfen Sie Ihre Eingaben oder versuchen Sie es später noch einmal.");
    }
  }
}
